var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfigedit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.7838,
    height: 22,
    rx: 2,
    fill: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 15.6667H8.28333L14.8 9.15L13.85 8.2L7.33333 14.7167V15.6667ZM6 17V14.1667L14.8 5.38333C14.9333 5.26111 15.0807 5.16667 15.242 5.1C15.4033 5.03333 15.5727 5 15.75 5C15.9273 5 16.0996 5.03333 16.2667 5.1C16.4338 5.16667 16.5782 5.26667 16.7 5.4L17.6167 6.33333C17.75 6.45556 17.8473 6.6 17.9087 6.76667C17.97 6.93333 18.0004 7.1 18 7.26667C18 7.44444 17.9696 7.614 17.9087 7.77533C17.8478 7.93667 17.7504 8.08378 17.6167 8.21667L8.83333 17H6ZM14.3167 8.68333L13.85 8.2L14.8 9.15L14.3167 8.68333Z",
    fill: "#5E5E5E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigedit);
export default __webpack_public_path__ + "static/media/configedit.c6613ca59b5dded14870d2018da83fc9.svg";
export { ForwardRef as ReactComponent };